export const MAX_NOTIFICATIONS = 20;

// Adds an auto-verify notification. Repeated no-change runs, "nothing to verify" notices or
// identical failures replace the latest unread one instead of stacking up on every interval.
const repeatKey = (notification) => {
  if (notification.outcome === 'verified') {
    return (notification.changes || []).length === 0 ? `verified:${notification.checked}` : null;
  }
  return `${notification.outcome}:${notification.message}`;
};

export const addAutoVerifyNotification = (notifications, notification) => {
  const latest = notifications[0];
  const key = repeatKey(notification);
  const isRepeat = key !== null
    && latest
    && !latest.read
    && latest.type === 'auto-verify'
    && repeatKey(latest) === key;

  if (isRepeat) {
    return [
      { ...latest, time: notification.time, repeatCount: (latest.repeatCount || 1) + 1 },
      ...notifications.slice(1),
    ];
  }
  return [{ ...notification, type: 'auto-verify', read: false }, ...notifications].slice(0, MAX_NOTIFICATIONS);
};

export const describeAutoVerifyNotification = (notification) => {
  const repeats = notification.repeatCount > 1 ? ` (×${notification.repeatCount})` : '';
  if (notification.outcome === 'verified') {
    const changes = notification.changes || [];
    return `${notification.checked} checked · ${changes.length === 0 ? 'no changes' : `${changes.length} changed`}${repeats}`;
  }
  return `${notification.message}${repeats}`;
};
